enum RestErrorCode {
  WrongCredentials = 'WrongCredentials',
  UnexpectedError = 'UnexpectedError',
  DuplicateEmail = 'DuplicateEmail',
  DuplicatePhone = 'DuplicatePhone',
  AlreadyExists = 'AlreadyExists',
  UserEmailNotFound = 'UserEmailNotFound',
  UserActivationFailed = 'UserActivationFailed',
  UserPasswordResetCodeNotFound = 'UserPasswordResetCodeNotFound',
  UserPasswordResetCodeExpired = 'UserPasswordResetCodeExpired',
  UserAvailabilityKeyDecodeFailed = 'UserAvailabilityKeyDecodeFailed',
  UserAvailabilityKeyExpired = 'UserAvailabilityKeyExpired',
  InvalidJobStatus = 'InvalidJobStatus',
  ResendLinkCouldNotBeCompleted = 'ResendLinkCouldNotBeCompleted',
}

export default RestErrorCode;
